import { useCreateComment } from './../../hooks'
import { Button } from 'core/components/form-controls';
import { useAuthModal } from "core/context";
import { _t } from "core/language";

const maxLength = 500;

export default function CommentBox({id, tab}: {id?: string | number, tab?: string}) {
  const { openModal, token } = useAuthModal();
  const { createComment, loading, text, setText } = useCreateComment(id, tab);

  if (!token) {
    return <div className='mx-4'><Button
      classBtn={`bg-primary w-full`}
      primary
      type="button"
      size="sm"
      onClickBtn={() => openModal(() => {})}
      label={_t("comunity.comment.not_login")}
    /></div>;
  }

  return (
    <div className="w-full max-w-md px-4">
      <div className={`border ${text.length ? 'border-primary' : 'border-[#B4BBC6]/50' } rounded-lg p-2 ${loading ? 'bg-gray-100' : ''}`}>
        <textarea
          className="w-full h-20 outline-none resize-none text-[#333333] text-[13px]"
          placeholder={_t("comunity.comment.placeholder")}
          value={text}
          onChange={(e) => setText(e.target.value)}
          maxLength={maxLength}
          disabled={loading}
          id="comment-box"
        />
        <div className="flex justify-end items-center mt-1 gap-3">
          <span className="text-gray-500 text-sm">
            {text.length}/{maxLength}
          </span>
          <Button
            classBtn={`${!text ? "!bg-[#999999] data-[disabled]:text-[#ffffff]" : "bg-primary [&_.animate-spin]:border-white [&_.animate-spin]:border-t-transparent"} !px-4 !py-1 rounded`}
            primary={!!text}
            type="button"
            size="sm"
            onClickBtn={() => createComment(text)}
            loading={loading}
            disabled={!text}
            label={_t("comunity.comment.submit")}
          />
        </div>
      </div>
    </div>
  );
}
